import { useTypedQuery } from '../helpers/useTypedQuery';

export const useCurrencies = () => {
  const { isLoading, data, refetch } = useTypedQuery(
    'get',
    '/common/currencies'
  );

  return {
    isLoading,
    refetch,
    currencies: data || []
  };
};
